import { isValid } from "date-fns";

/**
 * Validate if the object is a valid date
 * @param  	{Date} 					date 			Date to be validated
 * @return  {Boolean}									True if the date is valid
 */
export function isValidDate(date) {
  return date && isValid(date) && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}
